


















































































































































import { Component, Vue } from 'vue-property-decorator';
import DYHead from '@/components/Head/Index.vue';
import DYVideo from './Video.vue';
import DYVideo2 from './Video2.vue';
import axios from 'axios'

@Component({
  components: {
    DYHead,
    DYVideo,
    DYVideo2
  }
})
export default class Home extends Vue {

  private loading = true;

  private mounted() {
    console.log(222);
    this.$nextTick(()=> {
      this.loading = false;
    })
  }

  private isWechat():boolean {
    if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i)){
      return true;
    }
    return false;
  }


}
